import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Meet the topic",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is this asking of me today?",
      "Where does this sit in me right now?",
      "What feels too tender to say out loud?"
    ],
      [
      "What is this asking of me today?",
      "Where does this sit in me right now?",
      "What feels too tender to say out loud?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The first trigger",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the first trigger I can name?",
      "What do I feel in the first second?",
      "What did I need in that moment?"
    ],
      [
      "What is the first trigger I can name?",
      "What do I feel in the first second?",
      "What did I need in that moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What happens in the body",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where in my body do I feel this now?",
      "How is my breathing when this shows up?",
      "What is my body trying to tell me?"
    ],
      [
      "Where in my body do I feel this now?",
      "How is my breathing when this shows up?",
      "What is my body trying to tell me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The story I tell myself",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What thought appears right away?",
      "What story do I tell about it?",
      "What softer possibility exists?"
    ],
      [
      "What thought appears right away?",
      "What story do I tell about it?",
      "What softer possibility exists?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The need underneath",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the need underneath?",
      "How am I trying to meet it right now?",
      "How would I like to ask for it gently?"
    ],
      [
      "What is the need underneath?",
      "How am I trying to meet it right now?",
      "How would I like to ask for it gently?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small inner boundary",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small boundary would protect me today?",
      "Where do I cross my own boundary?",
      "How would an inner boundary sentence sound?"
    ],
      [
      "What small boundary would protect me today?",
      "Where do I cross my own boundary?",
      "How would an inner boundary sentence sound?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A pause in the middle",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the first sign the loop begins?",
      "What small pause is possible for me?",
      "What do I fear will happen if I pause?"
    ],
      [
      "What is the first sign the loop begins?",
      "What small pause is possible for me?",
      "What do I fear will happen if I pause?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Softness toward myself",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What soft word can I say to myself?",
      "What would I say to a friend in my place?",
      "What shifts in me when I hear it?"
    ],
      [
      "What soft word can I say to myself?",
      "What would I say to a friend in my place?",
      "What shifts in me when I hear it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "The fear underneath",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What fear is underneath?",
      "How do I protect myself from it?",
      "What do I need to feel a little safer?"
    ],
      [
      "What fear is underneath?",
      "How do I protect myself from it?",
      "What do I need to feel a little safer?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Soft responsibility",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my part without blaming myself?",
      "What is not mine to carry?",
      "What small choice is within my control?"
    ],
      [
      "What is my part without blaming myself?",
      "What is not mine to carry?",
      "What small choice is within my control?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One small new line",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What sentence do I usually say to myself?",
      "How would a gentler sentence sound?",
      "How do I want to feel after the next time?"
    ],
      [
      "What sentence do I usually say to myself?",
      "How would a gentler sentence sound?",
      "How do I want to feel after the next time?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Choosing connection",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is a small choice of connection for me?",
      "What makes it hard for me to choose it?",
      "What small movement can I make today?"
    ],
      [
      "What is a small choice of connection for me?",
      "What makes it hard for me to choose it?",
      "What small movement can I make today?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small direction forward",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I want the direction to go?",
      "What small value matters to me here?",
      "What small habit could help?"
    ],
      [
      "Where do I want the direction to go?",
      "What small value matters to me here?",
      "What small habit could help?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I let what arose be here."
    ],
      [
      "I let what arose be here."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle closure",
    opening: localizedGenderNode(
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ],
      [
      "Today I stay with myself around this topic.",
      "I do not solve.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about myself in this journey?",
      "What return sentence will I use for hard moments?",
      "How do I want to remember this breath?"
    ],
      [
      "What did I learn about myself in this journey?",
      "What return sentence will I use for hard moments?",
      "How do I want to remember this breath?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose presence before response."
    ],
      [
      "I choose presence before response."
    ]
    ),
    action: localizedGenderNode(
      "one breath.",
      "one breath."
    ),
  },
].map(buildNormalizedDay);

export const fearTheChildrenWillStayAwayFromMeHateMeBlueprintEn = buildNormalizedPilotBlueprint({
  id: "fear_the_children_will_stay_away_from_me_hate_me_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "fear_the_children_will_stay_away_from_me_hate_me",
  category: "parenting_children",
  journeyName: {
    he: "פחד “הילדים יתרחקו ממני / ישנאו אותי”",
    en: "Fear \"the children will stay away from me / hate me\"",
    es: "Miedo \"los niños se alejarán de mí / me odiarán\" — 18 ימים",
  },
  days,
});

export default fearTheChildrenWillStayAwayFromMeHateMeBlueprintEn;
